import { pathOr } from "ramda";
import React from "react";
import { Button, Card } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

const styles = {
  container: {
    margin: "24px",
  },
  button: {
    marginTop: "20px",
    height: "50px",
    backgroundColor: "#00becd",
    borderColor: "#00becd",
    color: "#ffffff",
    fontSize: "18px",
  },
};

const messagesDefinition = defineMessages({
  sent: {
    id: "modules.Malfunctions.components.Confirmation.sent",
    description: "Sent label",
    defaultMessage: "Your workorder is sent successfully.",
  },
  return: {
    id: "modules.Malfunctions.components.Confirmation.return",
    description: "Return label",
    defaultMessage: "Return to pending workorders.",
  },
});

const Confirmation = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const vehicleNumber = pathOr("", ["state", "vehicleNumber"], location);

  return (
    <Card className="text-center" style={styles.container}>
      <Card.Header>{intl.formatMessage(messagesDefinition.sent)}</Card.Header>
      <Card.Body>
        {location?.pathname === "/malfunctions/open-route/confirmation" && (
          <Button
            style={styles.button}
            onClick={() =>
              navigate(`/malfunctions/open/${vehicleNumber}`, { replace: true })
            }
          >
            {intl.formatMessage(messagesDefinition.return)}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

export default Confirmation;
